<template>
  <button
    :type="type"
    class="btn btn-block"
    :class="`btn-${color}`"
    v-on="$listeners">
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    type: {
      type: String,
      default: 'button'
    }
  },
}
</script>

<style>

</style>